/* import __COLOCATED_TEMPLATE__ from './adi-select.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';
import { modifier } from 'ember-modifier';

export default class CustomSelect extends Component {
  @service intl;

  updated = modifier((element) => {
    element.value = this.args.value.id;
  });

  @action onChange() {
    const selectElement = document.querySelector(`#${this.args.id} select`);
    if (selectElement) {
      let selectedIndex = this.args.prompt ? selectElement.selectedIndex - 1 : selectElement.selectedIndex;
      if (this.args.onValueChange) this.args.onValueChange(this.args.content[selectedIndex]);
    }
  }

  get options() {
    if (!(this.args.content && Array.isArray(this.args.content))) return [];

    return this.args.content.map((item) => {
      let description = null;

      if (!item.description) {
        let translation = `labels.${this.args.type}.${item.appName}`,
          tArgs = {};

        if (item.associatedData && item.associatedData.item) {
          translation = `${translation}_with_value`;
          tArgs = {
            value: item.associatedData.item.displayValue,
          };
        }

        description = this.intl.t(translation, tArgs);
      } else description = item.description;

      return {
        id: item.id,
        description: description,
        selected: item.id == this.args.value.id,
        disabled: item.isDisabled,
        divider: item.divider,
      };
    });
  }
}
